module.exports = __webpack_public_path__ + "img/logo.ba86b51c.png";